export const SECURITY_INCIDENT_REQUEST_ID = 'SEC06';
